// FieldWrapper.js
import { Label } from "./label";
import { Error } from "./error";

export const FieldWrapper = ({ label, error, children }) => (
  <div className="mb-3">
    {label && <Label>{label}</Label>}
    <div>{children}</div>
    <Error errorMessage={error?.message} />
  </div>
);
